export const Heartbeat = '0';
export const TestRequest = '1';
export const ResendRequest = '2';
export const Reject = '3';
export const SequenceReset = '4';
export const Logout = '5';
export const IOI = '6';
export const Advertisement = '7';
export const ExecutionReport = '8';
export const OrderCancelReject = '9';
export const Logon = 'A';
export const DerivativeSecurityList = 'AA';
export const NewOrderMultileg = 'AB';
export const MultilegOrderCancelReplace = 'AC';
export const TradeCaptureReportRequest = 'AD';
export const TradeCaptureReport = 'AE';
export const OrderMassStatusRequest = 'AF';
export const QuoteRequestReject = 'AG';
export const RFQRequest = 'AH';
export const QuoteStatusReport = 'AI';
export const QuoteResponse = 'AJ';
export const Confirmation = 'AK';
export const PositionMaintenanceRequest = 'AL';
export const PositionMaintenanceReport = 'AM';
export const RequestForPositions = 'AN';
export const RequestForPositionsAck = 'AO';
export const PositionReport = 'AP';
export const TradeCaptureReportRequestAck = 'AQ';
export const TradeCaptureReportAck = 'AR';
export const AllocationReport = 'AS';
export const AllocationReportAck = 'AT';
export const ConfirmationAck = 'AU';
export const SettlementInstructionRequest = 'AV';
export const AssignmentReport = 'AW';
export const CollateralRequest = 'AX';
export const CollateralAssignment = 'AY';
export const CollateralResponse = 'AZ';
export const News = 'B';
export const CollateralReport = 'BA';
export const CollateralInquiry = 'BB';
export const NetworkCounterpartySystemStatusRequest = 'BC';
export const NetworkCounterpartySystemStatusResponse = 'BD';
export const UserRequest = 'BE';
export const UserResponse = 'BF';
export const CollateralInquiryAck = 'BG';
export const ConfirmationRequest = 'BH';
export const TradingSessionListRequest = 'BI';
export const TradingSessionList = 'BJ';
export const SecurityListUpdateReport = 'BK';
export const AdjustedPositionReport = 'BL';
export const AllocationInstructionAlert = 'BM';
export const ExecutionAcknowledgement = 'BN';
export const ContraryIntentionReport = 'BO';
export const SecurityDefinitionUpdateReport = 'BP';
export const SettlementObligationReport = 'BQ';
export const DerivativeSecurityListUpdateReport = 'BR';
export const TradingSessionListUpdateReport = 'BS';
export const MarketDefinitionRequest = 'BT';
export const MarketDefinition = 'BU';
export const MarketDefinitionUpdateReport = 'BV';
export const ApplicationMessageRequest = 'BW';
export const ApplicationMessageRequestAck = 'BX';
export const ApplicationMessageReport = 'BY';
export const OrderMassActionReport = 'BZ';
export const Email = 'C';
export const OrderMassActionRequest = 'CA';
export const UserNotification = 'CB';
export const StreamAssignmentRequest = 'CC';
export const StreamAssignmentReport = 'CD';
export const StreamAssignmentReportACK = 'CE';
export const NewOrderSingle = 'D';
export const NewOrderList = 'E';
export const OrderCancelRequest = 'F';
export const OrderCancelReplaceRequest = 'G';
export const OrderStatusRequest = 'H';
export const AllocationInstruction = 'J';
export const ListCancelRequest = 'K';
export const ListExecute = 'L';
export const ListStatusRequest = 'M';
export const ListStatus = 'N';
export const AllocationInstructionAck = 'P';
export const DontKnowTrade = 'Q';
export const QuoteRequest = 'R';
export const Quote = 'S';
export const SettlementInstructions = 'T';
export const MarketDataRequest = 'V';
export const MarketDataSnapshotFullRefresh = 'W';
export const MarketDataIncrementalRefresh = 'X';
export const MarketDataRequestReject = 'Y';
export const QuoteCancel = 'Z';
export const QuoteStatusRequest = 'a';
export const MassQuoteAcknowledgement = 'b';
export const SecurityDefinitionRequest = 'c';
export const SecurityDefinition = 'd';
export const SecurityStatusRequest = 'e';
export const SecurityStatus = 'f';
export const TradingSessionStatusRequest = 'g';
export const TradingSessionStatus = 'h';
export const MassQuote = 'i';
export const BusinessMessageReject = 'j';
export const BidRequest = 'k';
export const BidResponse = 'l';
export const ListStrikePrice = 'm';
export const XMLnonFIX = 'n';
export const RegistrationInstructions = 'o';
export const RegistrationInstructionsResponse = 'p';
export const OrderMassCancelRequest = 'q';
export const OrderMassCancelReport = 'r';
export const NewOrderCross = 's';
export const CrossOrderCancelReplaceRequest = 't';
export const CrossOrderCancelRequest = 'u';
export const SecurityTypeRequest = 'v';
export const SecurityTypes = 'w';
export const SecurityListRequest = 'x';
export const SecurityList = 'y';
export const DerivativeSecurityListRequest = 'z';
